export function getSwissCantonImages(canton) {
  switch (canton) {
    case "AG":
      return "/images/ch/ag.png";
    case "AI":
      return "/images/ch/ai.png";
    case "AR":
      return "/images/ch/ar.png";
    case "BE":
      return "/images/ch/be.png";
    case "BL":
      return "/images/ch/bl.png";
    case "BS":
      return "/images/ch/bs.png";
    case "CH":
      return "/images/ch/ch.png";
    case "FR":
      return "/images/ch/fr.png";
    case "GE":
      return "/images/ch/ge.png";
    case "GL":
      return "/images/ch/gl.png";
    case "GR":
      return "/images/ch/gr.png";
    case "JU":
      return "/images/ch/ju.png";
    case "LU":
      return "/images/ch/lu.png";
    case "NE":
      return "/images/ch/ne.png";
    case "NW":
      return "/images/ch/nw.png";
    case "OW":
      return "/images/ch/ow.png";
    case "SH":
      return "/images/ch/sh.png";
    case "SO":
      return "/images/ch/so.png";
    case "SZ":
      return "/images/ch/sz.png";
    case "TG":
      return "/images/ch/tg.png";
    case "TI":
      return "/images/ch/ti.png";
    case "UR":
      return "/images/ch/ur.png";
    case "VD":
      return "/images/ch/vd.png";
    case "VS":
      return "/images/ch/vs.png";
    case "ZG":
      return "/images/ch/zg.png";
    case "ZH":
      return "/images/ch/zh.png";
    default:
      return null;
  }
}

/**
 * Determines the market based on the hostname (same approach as violators-portal).
 * Defaults to CH if the market can't be detected (e.g. localhost).
 *
 * @returns {"CH" | "DE" | "AT"}
 */
export function detectMarket() {
  const hostname = window.location.hostname;

  if (hostname.endsWith(".de")) {
    return "DE";
  } else if (hostname.endsWith(".at")) {
    return "AT";
  }
  return "CH";
}

const marketConfigs = {
  CH: { supportedLanguages: ["de", "en", "fr", "it"] },
  DE: { supportedLanguages: ["de", "en"] },
  AT: { supportedLanguages: ["de", "en"] },
};

export function getSupportedLanguages() {
  return marketConfigs[detectMarket()].supportedLanguages;
}

/**
 * Returns the Swiss canton image for the license plate, but only on the Swiss market.
 * On other markets the first two letters are a local district code (e.g. FR = Freiburg im Breisgau).
 */
export function getSwissCanton(licensePlate) {
  if (!licensePlate || detectMarket() !== "CH") return null;
  return getSwissCantonImages(licensePlate.slice(0, 2));
}

export function formatLicensePlateForDisplay(licensePlate) {
  return getSwissCanton(licensePlate)
    ? licensePlate.slice(0, 2) + "·" + licensePlate.slice(2)
    : licensePlate;
}

export function getCountryImages(country) {
  switch (country) {
    case "CH":
      return "/images/ch/ch.png";
    default:
      return null;
  }
}

export function getModalStyle() {
  return {
    modal: { backgroundColor: "#f2f2f2", padding: 0 },
    closeIcon: { backgroundColor: "red", fill: "white" },
  };
}

export function getModalStyleWithoutRedBackground() {
  return {
    modal: { backgroundColor: "#f2f2f2", padding: 0 },
    closeIcon: { backgroundColor: "#f2f2f2", fill: "red" },
  };
}
